// extracted by mini-css-extract-plugin
export default {"base":"badges-module__base--BEc"};